<template>

    <div class="container-fluid fixcontent " >

        <div class="row " style="margin-top: 1px; margin-bottom: -4px !important;" >
            <div class="col-md-2 text-light " style="padding-left: 0px !important;">
                <img class="col-md-12   " src="@/assets/images/headerlogo.png"   >
            </div>
            <div class="col-md-6 text-center col-7 mt-4 text-light offset-1 font-weight-semi-bold" style="font-size: 17px">
                <welcomenote/>

            </div>
            <div class="col-md-3 text-right col-4 text-light mt-1" style="font-size: 17px" >
                <p style="margin-bottom: 0.3rem"><ShowRealTime/></p>
                <a class="text-light" href="#" @click.prevent="signOut" >Login</a> / <a class="text-light" href="#" @click.prevent="signOut">Logout</a>
            </div>
        </div>

        <div class="row mt-2">
            <sidebar></sidebar>
            <div class="col-md-11 bgsecond mt-2 text-light">

                <div class="row mb-2 text-center">
                    <h1 class="col-md-12">Unslod Stock</h1>
                </div>
                <div class="row mt-2" >
                    <div class="col-md-2">
                        <!--                        <button class="btn-sm btn-info" @click="getinvoices">-->
                        <!--                            <span v-if="showloader" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>-->
                        <!--                            Refresh-->
                        <!--                        </button>-->
                    </div>
                    <div class="col-md-2">

                    </div>

                    <div class="col-md-2 ">

                    </div>

                    <!--                    <div class="col-md-2 text-right">-->
                    <!--                        <button class="btn-sm btn-warning"    @click="clearfilters" >Clear Filters</button>-->
                    <!--                    </div>-->

                </div>
                <div class="row mt-1">
                    <div v-if="showloader" class="col-md-10 offset-1 text-center">
                        <loader/>
                    </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-6 offset-3 ">
                      <div class="col-md-12 text-right">
                          <i class="fa fa-sync-alt"
                             style="cursor:pointer; font-size:20px;"
                             @click="()=>get_total_stock()"></i>
                      </div>


                      <table class="table table-bordered table-striped text-light">
                          <thead class="thead-dark">
                          <tr>
                              <th>Sr</th>

                              <th>Location</th>
                              <th>Cost Value</th>
                              <th class="text-right">Quantity</th>

                          </tr>
                          </thead>
                          <tbody >
                          <tr v-for="(location_stock,index ) in total_stock" :key="location_stock.location_id">
                              <td>{{ index + 1 }}</td>

                              <td>{{ location_stock.location.location_name }}</td>
                              <td class="text-right"> £{{ formatNumberWithCommas(Number(location_stock.total_stock_value).toFixed(2))}}</td>
                              <td class="text-right">{{ formatNumberWithCommas(Number(location_stock.total_stock).toFixed(2))}}</td>
                          </tr>


                          </tbody>
                      </table>
                      <table class="table text-light ">
                          <thead style="visibility: hidden">
                          <th class="col-md-11"></th>
                          <th>QTY</th>

                          </thead>
                          <tbody>
                          <tr class="">
                              <td>Grand Total </td>
                              <td>
                                  {{
                                      formatNumberWithCommas(total_stock
                                          .map(bstock => bstock.total_stock)
                                          .reduce((total, stock) => total + stock, 0)
                                          .toFixed(2))
                                  }}
                              </td>

                          </tr>

                          </tbody>
                      </table>
                  </div>
                </div>



            </div>

        </div>

    </div>

</template>

<script>
//import apiService from "@/service/apiService";
import { mapActions } from "vuex";
import { mapGetters } from 'vuex';
import { mapState } from 'vuex';
import sidebar from "@/components/layout/sidebar";
import showrealtime from "@/components/showrealtime";
import vSelect from "vue-select";
import Welcomenote from "@/pages/admin/mypos/welcomenote.vue";
import URL from "@/constants/baseurl";
import Loader from "@/components/loader.vue";
import moment from "moment/moment";
//import vSelect from "vue-select";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import apiService from "@/service/apiService";
import Swal from "sweetalert2";
import axios from "axios";
import {cloneDeep} from "lodash";


export default {
    name: "branch targets",

    components:{Loader, Welcomenote, 'v-select': vSelect,'sidebar': sidebar,'ShowRealTime':showrealtime},
    computed: {
        ...mapGetters(['AuthenticatedUser']),


        authenticatedUser() {
            let user = localStorage.getItem('user');
            user = JSON.parse(user)
            return user
        },


    },
    data() {
        return {
            saving:false,
            total_stock:[],


            showloader:false,






        };
    },
    async created() {
        //  await this.getUsers();
        //   await this.getRoles();
        // await this.getbranches()
        // await this.getcashiers()

        const promises = [

            this.reloadcb(),
            this.get_total_stock()



        ];
        this.showloader=true
        await Promise.all(promises);
        this.showloader=false

    },

    methods: {
        ...mapActions(['login', 'processLogoutManual']),
        ...mapActions('invoice', ['getbranches']),












        async reloadcb(){
            if(this.branches.length==0){

                //   alert(this.branches.length)
                await this.getbranches()
                // console.log(this.latestinvoices.data.length,'here')

            }

        },

        async get_total_stock() {
            this.showloader=true
            const apiToken = localStorage.getItem('token');

            try {
                const response = await fetch(`${URL.BASEURL}/api/get-total-stock`, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${apiToken}`
                    }
                });

                if (!response.ok) {
                   //
                } else {
                    const data = await response.json();

                    this.total_stock=data
                }





            } catch (err) {
                console.error('Error fetching total stock:', err);

            } finally {
                this.showloader=false
            }
        },

        formatNumberWithCommas(number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },






    },
}
</script>

<style scoped>
@import '../../../assets/styles/pos.css';
.hide {
    visibility: hidden !important;
}



</style>
